var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPersonal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_3",
    "data-name": "Artboard \\u2013 3",
    clipPath: "url(#clip-Artboard_3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#b3b9bb",
    opacity: 0.995
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_6",
    "data-name": "Intersection 6",
    d: "M0,132.091c1.13-3.22,2.525-5.587,4.247-6.419,8.2-3.96,24-10.415,28.408-11.993,18.756-6.716,6.723-10.564,24.637-16.537V92.781S46.864,87.417,43.649,68.207c0,0-5.836,2.756-5.5-5.971.3-7.753-2.626-17.881,5.812-13.505A85,85,0,0,1,42.29,14.18S53.423,0,76.848,0,111.4,14.18,111.4,14.18a84.891,84.891,0,0,1-1.69,34.551c8.44-4.376,5.479,5.753,5.78,13.505.337,8.726-5.7,5.971-5.7,5.971-3.215,19.21-13.918,24.574-13.918,24.574v4.361c17.914,5.972,6.156,9.821,24.91,16.537,4.408,1.579,20.41,8.033,28.616,11.993,1.852.894,3.327,3.565,4.5,7.163A100.007,100.007,0,0,1,0,132.091Z",
    transform: "translate(22.74 31.403)",
    fill: "#fff",
    opacity: 0.9
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonal);
export default __webpack_public_path__ + "static/media/icon-personal.773e3611fd229ee218d01befed72b1ec.svg";
export { ForwardRef as ReactComponent };